module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"checkbox-filter:accept":"Применить","checkbox-filter:reset":"Сброс"},"en":{"checkbox-filter:accept":"Accept","checkbox-filter:reset":"Reset"}}')
  delete Component.options._Ctor
}
